import React, { createContext, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { requestForToken, onMessageListener } from "../../helpers/firebase";

function ToastDisplay({ title, body }) {
  return (
    <div>
      <p>
        <b>{title}</b>
      </p>
      <p>{body}</p>
    </div>
  );
}

export const NotificationContext = createContext();

const NotificationWrapper = ({ children }) => {
  const [reloadMessages, setReloadMessages] = useState(false);
  const [oneTime, setOneTime] = useState(true);
  const [notification, setNotification] = useState(null);


  onMessageListener()
    .then((payload) => {
      setNotification(payload.notification);
    })
    .catch((err) => console.log("failed: ", err));

  useEffect(()=>{
    if(oneTime){
      setOneTime(false);
      requestForToken();
    }
  },[oneTime])

  useEffect(() => {
    if (notification !== null) {
      toast.success(
        <ToastDisplay title={notification.title} body={notification.body} />,
        { position: "bottom-right" }
      );
      setNotification(null);
      setReloadMessages(true);
    }
  }, [notification]);


  return <NotificationContext.Provider value={{reloadMessages, setReloadMessages}}>{children}</NotificationContext.Provider>;
};

export default NotificationWrapper;
